export default __webpack_public_path__ + "static/media/schedules-placeholder.28a36ebe.svg";